<div #cursorFollow class="cursor-follow" id="cursor-follow"></div>
<div #wrapper id="smooth-wrapper">
  <div #content id="smooth-content">
    <router-outlet></router-outlet>
  </div>
</div>
